import { Injectable } from '@angular/core';
import { QueryHandlingService } from '@akebono/core';
import { map } from 'rxjs/operators';

import { AddGreenCornerPriceGQL } from '../../modules/graphql/service/graphql-shared-familiar-service';
import { GreenCornerPriceFetchRefType } from './types/green-corner-price-fetch-ref.type';

@Injectable()
export class GreenCornerService {
  constructor(
    private readonly qhs: QueryHandlingService,
    private readonly addGreenCornerPriceGQL: AddGreenCornerPriceGQL,
  ) {}

  fetchGreenCornerPrice(): GreenCornerPriceFetchRefType {
    const ref = this.qhs.fetch(this.addGreenCornerPriceGQL);

    return {
      loading$: ref.loading,
      data$: ref.data.pipe(map((res) => res.addGreenCornerPrice)),
    };
  }
}
